import type { IconData } from '@stacksjs/iconify-core'

export const devicesMicrophoneOff: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 0H4v3L1 0L0 1l15 15l1-1l-2.865-2.865A7.98 7.98 0 0 0 16 6h-2.5a5.49 5.49 0 0 1-2.143 4.357l-1.073-1.073l.044-.031A4 4 0 0 0 12 6zm-1.424 13.576L8.48 11.48q-.237.02-.48.02A5.5 5.5 0 0 1 2.5 6H0a8 8 0 0 0 6.5 7.86V16h3v-2.14q.553-.105 1.076-.284\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesMicrophoneOff
